import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import CommonImage from '@components/CommonImage';

import MaterialCardItemView from '@features/materials/components/MaterialCardItemView';
import AddMatchingFabricTrimsModal from '@features/materials/components/AddMatchingFabricTrimsModal';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { deletePairMaterial, getPairMaterialList } from '@services/materialService';

import { formatPairMaterialApiResponse, matchingMaterialTabs } from '@utils/MaterialsUtil';
import { printApiError } from '@utils/Util';

import ConfirmationModal from '@/features/crm/components/ConfirmationModal';

const MatchingFaricAndTrims = ({ materialId, referenceNumber }) => {
	const [showAddMatchingModal, setShowAddMatchingModal] = useState(false);
	const [pairMaterialData, setPairMaterialData] = useState({ Fabric: [], Trims: [] });
	const [activeTab, setActiveTab] = useState('Fabric');
	const [selectedItem, setSelectedItem] = useState(null);
	const [remove, setRemove] = useState(false);
	const dispatch = useDispatch();
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const type = queryParams.get('type');

	const onMaterialClick = (item) => {
		let url = `/materials/view/${item?.materialId}?type=${type}`;
		window.open(url, '_blank');
	};

	const getPairMaterials = async () => {
		dispatch(openLoader());
		try {
			const fabricResponse = await getPairMaterialList(materialId, matchingMaterialTabs.Fabric);
			const trimsResponse = await getPairMaterialList(materialId, matchingMaterialTabs.Trims);

			setPairMaterialData({
				Fabric: formatPairMaterialApiResponse(fabricResponse),
				Trims: formatPairMaterialApiResponse(trimsResponse)
			});
		} catch (error) {
			printApiError(error);
		} finally {
			dispatch(closeLoader());
		}
	};

	const onAddSuccess = () => {
		getPairMaterials();
		setShowAddMatchingModal(false);
	};

	const onRemove = async () => {
		dispatch(openLoader());
		await deletePairMaterial(materialId, selectedItem?.materialId);
		getPairMaterials();
		dispatch(closeLoader());
		setRemove(false);
	};

	const onCloseModal = () => {
		setShowAddMatchingModal(false);
	};

	const onCloseDeleteModal = () => {
		setRemove(false);
	};

	useEffect(() => {
		getPairMaterials();
	}, []);

	return (
		<div className="mt-3 bg-white p-4">
			<span className="mt-3 mb-3 semibold-16">Connect Matching Fabrics and Trims</span>
			<div className="d-flex justify-content-between align-items-center">
				<div className="inner-tabs my-3">
					<ul>
						{Object.keys(matchingMaterialTabs).map((tab) => (
							<li
								key={tab}
								className={activeTab === tab ? 'active' : ''}
								onClick={() => setActiveTab(tab)}
							>
								{tab} ({pairMaterialData[tab]?.length || 0})
							</li>
						))}
					</ul>
				</div>
				<button
					className="button text size32 px-0 d-flex align-items-center gap-1"
					onClick={() => setShowAddMatchingModal(true)}
				>
					<span className="ml-1">Matching {activeTab}</span>
					<CommonImage src={'/icons/add-round.svg'} alt={'add'} />
				</button>
			</div>
			{pairMaterialData[activeTab]?.length > 0 ? (
				<div className="fabric-list-container">
					<MaterialCardItemView
						cardOrigin="PAIR_MATERIAL"
						materialsData={{ data: pairMaterialData[activeTab] }}
						onMaterialClick={onMaterialClick}
						setSelectedItem={setSelectedItem}
						setRemove={setRemove}
						cardModelName={'Materials'}
					/>
				</div>
			) : (
				<p className="alert common-empty-state">No matching {activeTab.toLocaleLowerCase()} added</p>
			)}

			{showAddMatchingModal && (
				<AddMatchingFabricTrimsModal
					primaryMaterialId={materialId}
					referenceNumber={referenceNumber}
					onAddSuccess={onAddSuccess}
					type={activeTab}
					onCloseModal={onCloseModal}
				/>
			)}
			{remove && (
				<ConfirmationModal
					title={'Delete'}
					closeModal={onCloseDeleteModal}
					description={` about deleting the matching ${activeTab}?`}
					callback={onRemove}
					footerType={'CLOSE'}
				/>
			)}
		</div>
	);
};

export default MatchingFaricAndTrims;
